import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './auth/AuthContext'
import ProtectedRoute from './auth/ProtectedRoute'
import Login from './pages/Login'
import AuthCallback from './pages/AuthCallback'
import Experiments from './pages/Experiments'
import Survey from './pages/Survey'
import Results from './pages/Results'
import Analytics from './pages/Analytics'
import AdminUsers from './pages/admin/Users'
import AdminTeams from './pages/admin/Teams'
import AdminTools from './pages/admin/Tools'
import AdminModels from './pages/admin/Models'
import AdminProductLifecycles from './pages/admin/ProductLifecycles'
import AdminQuestions from './pages/admin/Questions'

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/" element={<Navigate to="/experiments" replace />} />
          <Route path="/experiments" element={<ProtectedRoute><Experiments /></ProtectedRoute>} />
          <Route path="/survey" element={<ProtectedRoute><Survey /></ProtectedRoute>} />
          <Route path="/results" element={<ProtectedRoute><Results /></ProtectedRoute>} />
          <Route path="/analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute requiredRole="admin"><AdminUsers /></ProtectedRoute>} />
          <Route path="/admin/teams" element={<ProtectedRoute requiredRole="admin"><AdminTeams /></ProtectedRoute>} />
          <Route path="/admin/tools" element={<ProtectedRoute requiredRole="admin"><AdminTools /></ProtectedRoute>} />
          <Route path="/admin/models" element={<ProtectedRoute requiredRole="admin"><AdminModels /></ProtectedRoute>} />
          <Route path="/admin/product-lifecycles" element={<ProtectedRoute requiredRole="admin"><AdminProductLifecycles /></ProtectedRoute>} />
          <Route path="/admin/questions" element={<ProtectedRoute requiredRole="admin"><AdminQuestions /></ProtectedRoute>} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}
